import axios from 'axios';

const baseApiUrl = process.env.VUE_APP_API_URL;

export default {
  state: {
    status: undefined,
  },
  getters: {
    getStatus: state => state.status,
  },
  mutations: {
    set_status(state, status) {
      state.status = status;
    },
  },
  actions: {
    fetchStatus({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(baseApiUrl + '/status', { timeout: 3000 })
          .then(
            resp => {
              const data = resp.data;

              if (data != null) {
                if ('dbEngineUp' in data) {
                  commit('set_status', data.dbEngineUp);
                  resolve(resp);
                } else {
                  commit('set_status', false);
                  reject(resp);
                }
              } else {
                commit('set_status', false);
                reject(resp);
              }
            },
            err => {
              commit('set_status', false);
              reject(err);
            }
          )
          .catch(() => {
            commit('set_status', false);
            reject();
          });
      });
    },
  },
};
